import { metrics } from '@atlassian/browser-metrics/factory';
import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';
import {
	type PageSegmentLoadPerformanceEventConfig,
	BMEventsType,
} from '@atlassian/browser-metrics/types';

import type { LoadingMetricContentType } from './perf.config';

const timings = [
	{ key: 'lazy-load', startMark: 'lazy-load-start', endMark: 'lazy-load-end' },
	{ key: 'common-load', startMark: 'common-load-start', endMark: 'common-load-end' },
	{
		key: 'iframe-content-initialized',
		startMark: 'iframe-content-initialized-start',
		endMark: 'iframe-content-initialized-end',
	},
];

const loadingMetricsConfig: Record<
	LoadingMetricContentType,
	PageSegmentLoadPerformanceEventConfig
> = {
	viewPage: {
		key: 'embedded-confluence-view-page-iframe',
		type: BMEventsType.PAGE_SEGMENT_LOAD,
		timings,
	},
	editPage: {
		key: 'embedded-confluence-edit-page-iframe',
		type: BMEventsType.PAGE_SEGMENT_LOAD,
		timings,
	},
};

export const embeddedConfluenceIframeLoadMetrics = (
	contentType: LoadingMetricContentType,
): PageSegmentLoadMetric => metrics.pageSegmentLoad(loadingMetricsConfig[contentType]);
